import React from 'react'

export const ViewContext = React.createContext({
  breadcrumbs: [],
  setLoading: (loading) => {},
  containerInsets: { top: 0, left: 0, right: 0, bottom: 0 },
  containerSize: { width: 0, height: 0 },
})

export default ViewContext